import { REMOTE_SLICE_STORE_ADDRESS } from '../lib/createRemoteSlice';
import { overlaySlices } from '../overlays';
import { app } from './app';
import { auth } from './auth';
import { container } from './container';
import { featureFlags } from './featureFlags';
import { layout } from './layout';
import { locates } from './locates';
import { native } from './native';
import { onboarding } from './onboarding';
import { overlay } from './overlay';
import { recentlyUsedIndicators } from './recentlyUsedIndicators';
import { tab } from './tab';
import { theme } from './theme';
import { ui } from './ui';
import { workspace } from './workspace';
import { combineReducers } from 'redux';
import type { CombinedState, Reducer, StateFromReducersMapObject } from 'redux';

const reducersWithoutNavigation = {
    app,
    auth,
    container,
    featureFlags,
    layout,
    locates,
    native,
    onboarding,
    /** @deprecated */
    overlay,
    recentlyUsedIndicators,
    tab,
    theme,
    ui,
    workspace,
    [REMOTE_SLICE_STORE_ADDRESS]: combineReducers({
        ...Object.fromEntries(overlaySlices.map((slice) => [slice.name, slice.reducer])),
    }),
};

export type ReducersType = CombinedState<StateFromReducersMapObject<typeof reducersWithoutNavigation>>;

export const createRootReducer = (): Reducer<ReducersType> =>
    combineReducers(reducersWithoutNavigation) as Reducer<ReducersType>;
